import { useEffect } from 'react';
import { useCesium } from 'resium';

 const OptimizeTerrainLoading = () => {
  const { viewer } = useCesium();

  useEffect(() => {
    if (!viewer) return;

    // Prevent loading neighboring tiles
    viewer.scene.globe.preloadSiblings = false;

    // Optional: Set how far around the camera terrain is loaded (in meters)
    viewer.scene.globe.maximumScreenSpaceError = 5; // higher = faster but lower quality
    viewer.scene.globe.tileCacheSize = 100; // reduce cache size to avoid overfetching

    // Optional: Lower LOD loading priority
    viewer.scene.globe.loadingDescendantLimit = 5;
  }, [viewer]);

  return null;
};
export default OptimizeTerrainLoading;
